export const InspectionDocumentsParameters = {
  vehicleHistory: {
    items: [
      "Check For Any Outstanding Manufacturer Recalls",
      "Verify Vehicle Identification Number (Vin)",
      "Obtain Vehicle History Report",
      "Ensure Scheduled Maintenance Has Been Performed",
      "Check Emissions Compliance Sticker (If Applicable)",
    ],
  },
  roadTest: {
    items: [
      "Engine starts properly",
      "Engine idles smoothly",
      "Remote start system (if equipped) functions correctly",
      "Engine accelerates and cruises smoothly",
      "No abnormal engine noises (cold/hot & high/low speeds)",
      "Automatic/manual transmission shifts properly in cold and hot conditions",
      "No abnormal transmission noises (cold and hot)",
      "Shift interlock operates correctly",
      "Drive axle/transfer case functions without abnormal noise",
      "Clutch operation is smooth and responsive",
      "Steering is responsive, centered, and free of excessive play",
      "No abnormal body or suspension squeaks/rattles",
      "Struts/shocks operate properly",
      "Brakes, including ABS, function correctly",
      "Cruise control operates as expected",
      "Dashboard gauges function properly",
      "Driver memory settings (if equipped) work correctly",
      "No excessive wind noise in cabin",
    ],
  },

  vehicleExterior: {
    subHeads: [
      {
        title: "3A – BODY PANELS AND BUMPERS",
        item: [
          "No Signs Of Flood Damage",
          "No Signs Of Fire Damage",
          "No Major Accident Damage Detected",
          "No Hail Or Weather-Related Damage",
          "Body Panels Are Aligned And Free From Major Dents/Scratches",
          "Front And Rear Bumpers Are In Good Condition",
        ],
      },
      {
        title: "3B – DOORS, HOOD, TRUNK, AND TAILGATE",
        item: [
          "Doors Align And Function Correctly",
          "Hood Aligns And Functions Correctly",
          "Trunk Aligns And Functions Correctly",
          "Tailgate Aligns And Functions Correctly",
          "Roof Is Free Of Damage",
          "Hood Release Mechanism Operates Properly",
          "Hood Hinges Function Correctly",
          "Hood Prop Rod/Gas Struts Hold Securely",
          "Door Hinges Function Properly",
          "Trunk / Tailgate Hinges & Struts Function Correctly",
          "Power Liftgate (If Equipped) Operates Correctly",
        ],
      },
      {
        title: "3C – GRILLE, TRIM, AND ROOF RACK",
        item: [
          "Grille Is Intact And Undamaged",
          "Exterior Trim Is Secure And In Good Condition",
          "Roof Rack (If Equipped) Is Secure",
          "Running Boards (If Equipped) Function Properly",
        ],
      },
      {
        title: "3D – GLASS AND MIRRORS",
        item: [
          "Windshield Is Free Of Cracks Or Excessive Chips",
          "Side Windows Are Free Of Cracks Or Excessive Chips",
          "Rear Window Is Free Of Cracks Or Excessive Chips",
          "Wiper Blades Are In Good Condition",
          "Exterior Mirrors Are Undamaged",
          "Power/Folding Mirrors Operate Properly",
        ],
      },
      {
        title: "3E – EXTERIOR LIGHTS",
        item: [
          "Front Headlights Function Correctly",
          "Rear Taillights Function Correctly",
          "Side Marker Lights Function Correctly",
          "Hazard Lights Operate Properly",
          "Automatic On/Off Lighting (If Equipped) Works Correctly",
          "Trailer Light Connector (If Equipped) Functions Properly",
        ],
      },
    ],
  },
  vehicleInterior: {
    subHeads: [
      {
        title: "4A – AIRBAGS AND SEATBELTS",
        item: ["Airbags present and undamaged", "Seatbelts function correctly"],
      },
      {
        title: "4B – AUDIO AND SECURITY SYSTEMS",
        item: [
          "Radio and speaker system work correctly",
          "Antenna is intact and functional",
          "Alarm/theft-deterrent system operates correctly",
          "Navigation system (if equipped) functions properly",
        ],
      },
      {
        title: "4C – CLIMATE CONTROL SYSTEM",
        item: [
          "Air conditioning functions properly",
          "Heating functions properly",
          "Defrost and defogging systems operate correctly",
        ],
      },
      {
        title: "4D – INTERIOR AMENITIES",
        item: [
          "Clock displays accurate time",
          "Steering wheel tilt/telescopic function works correctly",
          "Steering column lock operates properly",
          "Steering wheel buttons (if equipped) function correctly",
          "Horn operates properly",
          "Warning chimes sound as expected",
          "Dashboard warning lights function correctly",
          "Windshield wipers function correctly",
          "Rear window wiper (if equipped) works correctly",
          "Windshield washers spray properly",
          "Interior lights function properly",
          "Rearview Mirror Adjusts Properly",
          "Auto-Dimming Mirror (If Equipped) Works Correctly",
          "Blind-Spot Monitoring System (If Equipped) Functions Correctly",
          "Rearview Camera System (If Equipped) Operates Correctly",
          "Infotainment System Functions Properly",
          "Reset Factory Settings If Necessary",
          "Parking Assist System (If Equipped) Functions Correctly",
          "Rear Entertainment System (If Equipped) Works Properly",
          "Power Outlets And Charging Ports Function Properly",
          "Cigarette Lighter (If Equipped) Functions Correctly",
          "Ashtray (If Equipped) Is Clean And Operational",
          "Glove Box Functions Correctly",
          "Center Armrest/Console Is In Good Condition",
          "Sun Visors And Vanity Mirrors Operate Correctly",
          "Adjustable Pedals (If Equipped) Work Properly",
        ],
      },
      {
        title: "4E – CARPET, TRIM, AND MATS",
        item: [
          "Interior Is Free Of Excessive Odors",
          "Carpeting Is Clean And Undamaged",
          "Floor Mats Are In Place And In Good Condition",
          "Door Panels Are Intact And Undamaged",
          "Headliner Is Secure And Undamaged",
        ],
      },
      {
        title: "4F – SEATS",
        item: [
          "Seat Upholstery Is In Good Condition",
          "Seat Adjustments Function Properly",
          "Folding Seat Mechanisms Work Correctly",
          "Heated Seats (If Equipped) Function Properly",
          "Cooled Seats (If Equipped) Function Properly",
          "Integrated Child Safety Seats (If Equipped) Work Correctly",
        ],
      },
    ],
  },
  vehicleDiagnostics: {
    items: ["Perform diagnostic scan for error codes"],
  },
  underhoodComponents: {
    subHeads: [
      {
        title: "6A – FLUID LEVELS",
        item: [
          "Engine oil and filter replaced",
          "Coolant level checked and topped up",
          "Brake fluid checked and topped up",
          "Transmission fluid checked and topped up",
          "Power steering fluid checked and topped up",
          "Windshield washer fluid topped up",
        ],
      },
      {
        title: "6B – ENGINE INSPECTION",
        item: [
          "No visible fluid leaks",
          "Hoses and belts in good condition",
          "Battery terminals clean and secure",
          "Engine mounts intact",
          "Timing belt/chain inspected",
        ],
      },
    ],
  },
  underbodyComponents: {
    subHeads: [
      {
        title: "7A – FRAME AND STRUCTURE",
        item: ["No structural damage detected"],
      },
      {
        title: "7B – EXHAUST SYSTEM",
        item: [
          "No exhaust leaks or abnormal noise",
          "Emission control system intact",
        ],
      },
      {
        title: "7C – TRANSMISSION & DRIVETRAIN",
        item: [
          "Transmission operates smoothly",
          "Transfer case (if equipped) functions correctly",
          "Differential is free of leaks",
        ],
      },
      {
        title: "7D – SUSPENSION AND BRAKES",
        item: [
          "Suspension components in good condition",
          "Brakes function properly",
          "Brake pads and rotors within safe limits",
        ],
      },
      {
        title: "7E – TIRES AND WHEELS",
        item: [
          "Tires match and are the correct size",
          "Tire tread depth meets safety standards",
          "Tire pressure at recommended levels",
          "Wheels undamaged and balanced",
        ],
      },
    ],
  },
  finalChecks: {
    items: [
      "Owner’s manual present",
      "Keys and remote controls function correctly",
      "Fuel level sufficient for test drives",
    ],
  },
}
